import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M50.5 20.8h115.4c11 0 18.4 4.9 22.6 12.9 2.1 4.3 3 8.9 3 12l-.3 1.7-19 64.4c-.9 3.4-4.5 5.2-8 4.3-3.6-.9-5.4-4.3-4.5-7.7l19-64.4-.3 1.7c0-1.4-.3-4-1.5-6.3-1.8-3.7-5.1-5.7-10.7-5.7H49.6l9.2 8.9c2.7 2.6 2.7 6.6 0 8.9-2.7 2.6-6.8 2.6-9.2 0L29.7 32.3c-2.7-2.6-2.7-6.6 0-8.9L49.6 3.9c2.7-2.6 6.8-2.6 9.2 0 2.7 2.6 2.7 6.6 0 8.9l-8.3 8zM38.9 31.7c0 .3.3.3 0 0zm110.6 147.5H34.1c-11 0-18.4-4.9-22.6-12.9-2.1-4.3-3-8.9-3-12l.3-1.7 19-64.4c.9-3.4 4.5-5.2 8-4.3 3.6.9 5.4 4.3 4.5 7.7L21.6 156l.3-1.7c0 1.4.3 4 1.5 6.3 1.8 3.7 5.1 5.7 10.7 5.7h116.6l-9.2-8.9c-2.7-2.6-2.7-6.6 0-8.9 2.7-2.6 6.8-2.6 9.2 0l19.9 19.2c2.7 2.6 2.7 6.6 0 8.9l-20.2 19.5c-2.7 2.6-6.8 2.6-9.2 0-2.7-2.6-2.7-6.6 0-8.9l8.3-8zm11.9-10.9c-.3-.3 0-.3 0 0zM142.7 88c3.6 0 6.5-2.9 6.5-6.3s-3-6.3-6.5-6.3H76.4c-3.6 0-6.5 2.9-6.5 6.3s3 6.3 6.5 6.3h66.3zm-19.1 36.6c3.6 0 6.5-2.9 6.5-6.3s-3-6.3-6.5-6.3h-66c-3.6 0-6.5 2.9-6.5 6.3s3 6.3 6.5 6.3h66z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}